import { useContext } from 'react';
import { ToastQueueContext } from './toast-queue-context';

export function useToastQueue() {
  const context = useContext(ToastQueueContext);
  if (context === undefined) {
    throw new Error('useToastQueue must be used within an ToastQueueProvider');
  }
  return context;
}
